/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Err_Tournament_No_Round_In_ProgressInputs */



/**
* | output |
* | --- |
* | "No rounds in progress" |
*
* @param {Err_Tournament_No_Round_In_ProgressInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const err_tournament_no_round_in_progress = /** @type {((inputs?: Err_Tournament_No_Round_In_ProgressInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Err_Tournament_No_Round_In_ProgressInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucune ronde en cours")
	if (locale === "es") return /** @type {LocalizedString} */ ("No hay ninguna ronda en progreso")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Nenhuma rodada em andamento")
	if (locale === "it") return /** @type {LocalizedString} */ ("Nessun round in corso")
	return /** @type {LocalizedString} */ ("No rounds in progress")
});